import React from 'react'
import MessageUtils from '../../../util/MessageUtils'
import SelectMultiSF from '../../../widgets/input/SelectMultiSF'
import ViewOrUpdate2UI from '../../../widgets/layout/ViewOrUpdate2UI'
import './TaskDetailTop.css'

const TaskUsersUI = ({context, messageList, project, projectUserList, projectUserMap, taskUserIdList,
    editMode, onEditClick, onChange, onSubmit
  }) =>
  <ViewOrUpdate2UI
    messageList={messageList}
    labelKey='c_watchers'
    value={projectUserMap && taskUserIdList && taskUserIdList.length > 0 ?
      taskUserIdList
        .filter(userId => projectUserMap[userId])
        .map(userId => projectUserMap[userId].name).join(', ') :
      MessageUtils.getMessageValue(messageList, 'c_none')
    }
    editable={project.permissionList.includes('prj_participate')}
    editMode={editMode}
    onEditClick={onEditClick}
  >
    <SelectMultiSF
      messageList={messageList}
      optionList={projectUserList
        .filter(projectUser => projectUser.roleId !== null)
        .map(projectUser => ({value: projectUser.userId, label: projectUser.name}))
      }
      onChange={onChange}
      onClickOutside={onSubmit}
      selectedKeys={taskUserIdList}
      menuIsOpen={editMode}
      placeholderKey='c_select'
    />
  </ViewOrUpdate2UI>

export default TaskUsersUI
